import {PersonalisationDataRetrievedESB} from "@next/eventservice"

const personaliationDataRetrieved = new PersonalisationDataRetrievedESB()

export const PublishPersonalisationDataRetrieved = () => {
    personaliationDataRetrieved.publish()
}

export const SubscribePersonalisationDataRetrieved = (cb: () => void) => {
    return personaliationDataRetrieved.subscribe(cb)
}
